import { render, staticRenderFns } from "./DesignBar.vue?vue&type=template&id=57d2e3f2&scoped=true"
import script from "./DesignBar.vue?vue&type=script&lang=js"
export * from "./DesignBar.vue?vue&type=script&lang=js"
import style0 from "./DesignBar.vue?vue&type=style&index=0&id=57d2e3f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d2e3f2",
  null
  
)

export default component.exports